module.exports = __webpack_public_path__ + "static/bewalletLogo-bc043cf133fbf438fab3e9f46845a666.svg";